export default {
  login: {
    welcome: '欢迎回来',
    subtitle: '登录继续购物',
    phonePlaceholder: '请输入手机号',
    passwordPlaceholder: '请输入密码',
    showPassword: '显示',
    hidePassword: '隐藏',
    loginButton: '登录',
    registerButton: '免费注册',
    title: '登录',
    subtitle2: '一站式全球购物赚取回馈',
    logging: '登录中...',
    phoneRequired: '请输入手机号',
    passwordRequired: '请输入密码',
    loginSuccess: '登录成功',
    loginFailed: '登录失败',
    loginError: '登录错误，请稍后重试'
  },
  register: {
    title: '创建账户',
    subtitle: '加入我们，开始您的交易之旅',
    username: '用户名',
    phone: '手机号',
    loginPassword: '登录密码',
    transactionPassword: '交易密码',
    invitationCode: '邀请码',
    usernamePlaceholder: '请输入用户名',
    phonePlaceholder: '请输入手机号',
    loginPasswordPlaceholder: '请输入登录密码',
    transactionPasswordPlaceholder: '请输入交易密码',
    invitationCodePlaceholder: '请输入邀请码',
    registerButton: '注册',
    hasAccount: '已有账户？登录',
    errorUsername: '请输入用户名',
    errorPhone: '请输入手机号',
    errorLoginPassword: '请输入登录密码',
    errorTransactionPassword: '请输入交易密码',
    errorInviteCode: '请输入邀请码',
    registerSuccess: '注册成功'
  },
  tabbar: {
    home: '首页',
    purchase: '订单记录',
    grabbing: '下单',
    kefu: '客服',
    my: '我的'
  },
  home: {
    orderCount: '订单数量',
    upgradeAmount: '充值升级',
    recharge: '充值',
    withdraw: '提现',
    team: '团队管理',
    commission: '获取佣金',
    newProducts: '新品上市',
    newProductsDesc: '全新季节及未来系列最新款。',
    buyNow: '立即购买',
    nowAvailable: '现已上市',
    nowAvailableDesc: '为婚礼季做好准备，为您的下一次旅行打包，无需承诺即可更新您的衣橱。通过我们的新借用计划，您可以尝试最新趋势并坚持您的预算，无需订阅。',
    footerTitle: 'Desigual.com',
    footerFollow: "关注我们 {'@'}Desigual.com 并分享您最喜爱的 Desigual.com 造型！",
    footerShop: '浏览我们的动态'
  },
  purchase: {
    all: '全部',
    pending: '待处理',
    completed: '已完成',
    frozen: '冻结中',
    balance: '账户余额',
    orderTime: '抢单时间',
    orderId: '抢单编号',
    totalAmount: '订单总额',
    commission: '佣金',
    expectedReturn: '预计返还',
    submitOrder: '提交订单',
    orderCompleted: '订单完成',
    loading: '加载中...',
    noData: '暂无订单数据',
    noMore: '没有更多了',
    orderSuccess: '抢单成功',
    orderNumber: '抢单编号',
    rating: '评价',
    notSubmit: '暂不提交',
    submitNow: '立即提交',
    submitting: '提交中...',
    submitFailed: '提交失败',
    grabOrderFailed: '抢单失败，请稍后重试',
    getOrderInfoFailed: '获取订单详情失败',
    submitOrderFailed: '提交失败，请稍后重试'
  },
  common: {
    home: '首页',
    about: '关于',
    contact: '联系我们',
    purchase: '订单记录',
    grabbing: '下单',
    my: '我的',
    login: '登录',
    register: '注册',
    kefu: '客服',
    loadDataError: '加载数据失败，请稍后重试',
    success: '操作成功',
    failed: '操作失败',
    submitSuccess: '提交成功',
    submitFailed: '提交失败',
    submitting: '提交中...'
  },
  grabbing: {
    accountAmount: '账户金额',
    accountBalance: '账户余额',
    getCommission: '获取佣金',
    ordersGrabbedToday: '已抢单数',
    orderCount: '订单数量',
    operationSteps: '操作步骤',
    step1: '1、点击开始任务按钮根据提示完成任务',
    step2: '2、完成任务以后就可以结算佣金到余额',
    grabOrder: '去抢单',
    pleaseWait: '请稍等',
    grabSuccess: '抢单成功',
    grabTime: '抢单时间',
    grabNumber: '抢单编号',
    orderTotal: '订单总额',
    commission: '佣金',
    expectedReturn: '预计返还',
    rating: '评价',
    notSubmit: '暂不提交',
    submitNow: '立即提交',
    submitting: '提交中...'
  },
  kefu: {
    title: '客服',
    intro: {
      line1: '如果您有什么问题或者需要帮助，',
      line2: '请联系在线客服为您解决'
    },
    serviceTime: {
      label: '服务时间',
      text: '您的专属客服',
      online: '在线'
    },
    contact: {
      title: '联系',
      name: '在线',
      status: '咨询',
      feature1: '即时回复',
      feature2: '专业服务',
      button: '联系'
    },
    faq: {
      title: '常见问题解答',
      rechargeQuestion: '如何充值？',
      rechargeAnswer: '您可以通过我们的安全支付网关充值。前往我的账户 > 充值并按照说明操作。',
      withdrawQuestion: '如何提现？',
      withdrawAnswer: '提现可以通过我的账户 > 提现进行。请确保您的账户已验证。',
      minRechargeQuestion: '最低充值金额是多少？',
      minRechargeAnswer: '最低充值金额为 ${currency}68。',
      withdrawTimeQuestion: '提现需要多长时间？',
      withdrawTimeAnswer: '提现通常在 24 小时内处理完成。',
      securityQuestion: '我的信息安全吗？',
      securityAnswer: '是的，我们使用行业标准加密技术来保护您的个人和财务信息。'
    }
  },
  my: {
    inviteCode: '邀请码',
    copy: '复制',
    copySuccess: '复制成功',
    copyFailed: '复制失败',
    online: '在线',
    accountBalance: '账户金额',
    balance: '账户余额',
    accountBalanceTrend: '账户余额',
    todayCommission: '今日佣金',
    totalCommission: '总佣金',
    today: '今日',
    total: '总计',
    todayOrders: '已抢单数',
    orderCount: '订单数量',
    recharge: '充值',
    withdraw: '提现',
    rechargeRecord: '充值记录',
    withdrawRecord: '提现记录',
    accountDetails: '账户明细',
    receivingAccount: '收款账户',
    bankAccount: '银行账户',
    bankAccountDesc: '银行账户',
    usdt: 'USDT',
    usdtDesc: 'USDT地址',
    connect: '连接',
    teamManagement: '团队管理',
    viewTeam: '查看团队',
    changePassword: '修改密码',
    changeWithdrawPassword: '修改提现密码',
    passwordSettings: '密码设置',
    logout: '退出登录',
    signOut: '退出登录',
    version: '版本'
  },
  changePasswordPage: {
    currentPassword: '当前登录密码',
    currentPasswordPlaceholder: '输入当前密码',
    newPassword: '新登录密码',
    newPasswordPlaceholder: '输入新密码',
    confirmPassword: '确认登录密码',
    confirmPasswordPlaceholder: '确认新密码',
    notice: '登录密码用于账户登录。密码必须至少6个字符，并包含字母和数字以确保安全。',
    updateButton: '更新登录密码',
    errorOldPassword: '请输入当前密码',
    errorNewPassword: '请输入新密码',
    errorConfirmPassword: '请确认新密码',
    errorPasswordMismatch: '两次输入的密码不一致',
    errorPasswordLength: '密码必须至少6个字符',
    errorPasswordFormat: '密码必须包含字母和数字'
  },
  changeWithdrawPasswordPage: {
    currentPassword: '当前提现密码',
    currentPasswordPlaceholder: '输入当前提现密码',
    newPassword: '新提现密码',
    newPasswordPlaceholder: '输入新提现密码',
    confirmPassword: '确认提现密码',
    confirmPasswordPlaceholder: '确认新提现密码',
    notice: '提现密码用于资金提现操作。密码必须至少6个字符，并包含字母和数字以确保安全。',
    updateButton: '更新提现密码',
    errorOldPassword: '请输入当前提现密码',
    errorNewPassword: '请输入新提现密码',
    errorConfirmPassword: '请确认新提现密码',
    errorPasswordMismatch: '两次输入的密码不一致',
    errorPasswordLength: '密码必须至少6个字符',
    errorPasswordFormat: '密码必须包含字母和数字'
  },
  details: {
    loading: '加载中...',
    noRecords: '没有记录哦',
    noMore: '没有更多了',
    time: '时间',
    type: '类型',
    amount: '金额',
    balance: '余额',
    remark: '备注',
    type0: '其他',
    type1: '充值',
    type2: '提现',
    type3: '交易',
    type4: '订单佣金',
    type5: '下级返佣',
    type8: '提现驳回'
  },
  rechargeRecord: {
    offline: '线下充值',
    online: '线上充值',
    loading: '加载中...',
    noRecords: '没有记录哦',
    orderNo: '订单编号',
    rechargeAmount: '充值金额',
    rechargeTime: '充值时间',
    payMethod: '支付方式',
    rechargeStatus: '充值状态',
    noMore: '没有更多了',
    statusPending: '待审核',
    statusApproved: '审核通过',
    statusFailed: '审核失败',
    statusEmpty: ''
  },
  withdrawRecord: {
    loading: '加载中...',
    noRecords: '没有记录哦',
    orderNo: '订单编号',
    withdrawAmount: '提现金额',
    withdrawTime: '提现时间',
    withdrawAddress: '提现地址',
    withdrawStatus: '提现状态',
    noMore: '没有更多了',
    statusPending: '提现中',
    statusApproved: '提现成功',
    statusFailed: '提现失败',
    statusEmpty: ''
  },
  withdraw: {
    title: '提现',
    method: '提现方式',
    methodSubtitle: '请选择您的提现方式',
    bankInfo: '银行账户信息',
    bankName: '所属银行',
    accountHolder: '开户名',
    bankCard: '银行卡',
    amount: '提现金额',
    balance: '余额',
    withdrawAll: '全部提现',
    paymentPassword: '支付密码',
    passwordPlaceholder: '请输入资金密码',
    principal: '本金金额',
    serviceFee: '服务费',
    netAmount: '净金额',
    notice: '*请仔细核对收款信息',
    withdrawButton: '提现',
    walletAddress: '钱包地址',
    walletAddressSubtitle: '请输入钱包地址'
  },
  recharge: {
    title: '充值',
    amount: '充值金额',
    amountSubtitle: '请输入您要充值的金额',
    quickSelect: '快速选择',
    rechargeNow: '立即充值',
    selectPayment: '选择支付方式',
    selectPaymentSubtitle: '请选择您喜欢的支付方式',
    cancel: '取消',
    confirm: '确认',
    crypto: '数字货币',
    bank: '银行转账',
    paymentRange: '最低: {symbol}{minAmount} - 最高: {symbol}{maxAmount}',
    rechargeFailed: '充值失败',
    paymentInfo: '支付信息',
    usercode: 'USDT地址',
    uploadScreenshot: '请提交付款截图',
    clickToUpload: '点击上传截图',
    copySuccess: '复制成功',
    copyFailed: '复制失败',
    uploadScreenshotRequired: '请上传付款截图',
    submit: '提交',
    submitting: '提交中...',
    submitSuccess: '提交成功',
    submitFailed: '提交失败'
  },
  bindUsdt: {
  title: '绑定USDT',
  cardTitle: 'USDT地址',
  cardSubtitle: '输入您的USDT钱包地址',
  walletAddress: '钱包地址',
  walletAddressPlaceholder: '请输入USDT钱包地址',
  networkType: '网络类型',
  networkTypePlaceholder: '请选择网络类型',
  withdrawPassword: '提现密码',
  withdrawPasswordPlaceholder: '请输入提现密码',
  trc20: 'TRC20',
  trc20Network: 'TRC20网络',
  erc20: 'ERC20',
  erc20Network: 'ERC20网络',
  securityNotice: '安全提示',
  securityText1: '• 您的USDT地址已加密并安全存储',
  securityText2: '• 只有您可以查看和修改此信息',
  securityText3: '• 请确保所有信息准确无误',
  buttonText: '保存信息',
  buttonSubtitle: '绑定USDT地址',
  errorWalletAddress: '请输入钱包地址',
  errorNetworkType: '请选择网络类型',
  errorWithdrawPassword: '请输入提现密码'
},
  team: {
  title: '团队管理',
  level1: '一级团队',
  level2: '二级团队',
  level3: '三级团队',
  level1Members: '一级团队成员',
  level2Members: '二级团队成员',
  level3Members: '三级团队成员',
  totalMembers: '总成员数',
  totalCommission: '总佣金',
  members: '人',
  orders: '订单数',
  commission: '佣金',
  noMembers: '暂无成员',
  loading: '加载中...',
  noMore: '没有更多了'
},
  bindBank: {
    title: '绑定银行卡',
    cardTitle: '银行信息',
    cardSubtitle: '选择您的银行并输入账户详情',
    bankName: '开户银行',
    bankNamePlaceholder: '请输入开户银行',
    cardNumber: '银行卡号',
    cardNumberPlaceholder: '请输入银行卡号',
    realName: '真实姓名',
    realNamePlaceholder: '请输入真实姓名',
    withdrawPassword: '提现密码',
    withdrawPasswordPlaceholder: '请输入提现密码',
    securityNotice: '安全提示',
    securityText1: '• 您的银行信息已加密并安全存储',
    securityText2: '• 只有您可以查看和修改此信息',
    securityText3: '• 请确保所有信息准确无误',
    buttonText: '保存信息',
    buttonSubtitle: '绑定银行账户',
    errorBankName: '请输入开户银行',
    errorCardNumber: '请输入银行卡号',
    errorRealName: '请输入真实姓名',
    errorWithdrawPassword: '请输入提现密码'
}
}
